import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { User } from "../../interfaces/user";
import { LanguageService } from '../languageService/language.service';
import { RequestService } from '../requestService/request.service';
import { SwitchDialogService } from '../switchDialogService/switch-dialog-service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private env = environment;
  private termParamsTimer;
  private user: User;
  private serverConfigs;
  private subscriber;
  getLoggedInStatus = new Subject();
  onChangeLanguage = new Subject();
  constructor(private requestService: RequestService, private switchDialogService: SwitchDialogService, private languageService: LanguageService) { }

  /* *** User *** */
  // Set and Get Functions
  setGuestUser(data) {
    this.user = {
      id: 0,
      displayName: null,
      avatar: null,
      email: null,
      rating: null,
      permissions: null,
      isGuest: true,
      type: 3,
      language: this.languageService.getLanguage()
    }
  };

  setUser(data) {
    this.user = data;
    this.languageService.setLanguage(this.user.language);
  };

  getUser() {
    return this.user;
  };

  //Reset User
  resetUser() {
    this.user = null;
  };

  /* *** Subscriber *** */
  // Set and Get Functions
  setSubscriber(data) {
    this.subscriber = data;
  };

  getSubscriber() {
    return this.subscriber;
  };

  //Reset Subscriber
  resetSubscriber() {
    this.subscriber = null;
  };

  // Check if the user is logged in or not
  isLoggedIn(): boolean {
    return this.user ? true : false;
  }

  // Function which is called on logout or if the user is unauthorized
  onLogout() {
    this.resetSubscriber();
    this.resetUser();
    this.getLoggedInStatus.next();
    location.hash = "#/login";
  }

  /* *** Terminal Params *** */
  // Set and Get Functions
  setServerConfigs(data) {
    this.serverConfigs = data && data.data && data.data.terminalParameters ? data.data.terminalParameters : {};
    this.languageService.setLanguages(["el", "en"]); /*  */
    // Create an updating mechanism
    let self = this;
    let intervalTime = this.serverConfigs.heartbitInterval ? this.serverConfigs.heartbitInterval * 60000 : 60 * 60000;
    clearInterval(this.termParamsTimer);
    this.termParamsTimer = setInterval(function () {
      self.getTerminalParams().then((configs: any) => {
        self.setServerConfigs(configs);
      })
    }, intervalTime);
  };

  getServerConfigs() {
    return this.serverConfigs;
  };

  // Return an instance of language service
  getLanguageService() {
    return this.languageService;
  }

  // Get Token and save it to local storage
  getToken() {
    localStorage.removeItem("appT");
    let req = {
      url: "/api/auth/start",
      excludeToken: true,
      req: {
        apiKey: this.env.apiKey,
        language: this.languageService.getLanguage(),
        parentalRating: this.getUser() && this.getUser().rating != null ? this.getUser().rating : 4
      }
    };

    return new Promise(resolve => {
      this.requestService.mainPostRequest(req).then((resp: any) => {
        localStorage.setItem("appT", resp.data.token);
        resolve(resp)
      })
    })
  }

  // Get User Info
  getUserInfo() {
    let req = {
      url: "/api/auth/info"
    };
    return this.requestService.mainGetRequest(req);
  }

  // Get server configurations
  getTerminalParams() {
    let req = {
      url: "/api/apps/getTerminalParams"
    };
    return this.requestService.mainPostRequest(req);
  }

  // Check user status
  checkStatus(info) {
    if (info && info.success) {
      if (info.data && info.data.profile) {
        this.setSubscriber(info.data.subscriber);
        this.setUser(info.data.profile);
        this.checkOnBoarded(info.data).then(boardResp => { });
      } else if (info.data && info.data.subscriber) {
        this.setSubscriber(info.data.subscriber);
        this.checkOnBoarded(info.data).then(boardResp => {
          this.switchDialogService.openSwitchProfileDialog(this);
        });
      } else if (info.data && info.data.guest) {
        this.setGuestUser(info.data.guest);
      }
    } else {
      this.resetUser();
      // If it is not in register or forgot password page go to login page
      if (location.hash.indexOf("register") == -1 && location.hash.indexOf("resetPassword") == -1) {
        location.hash = "#/login";
      }

    }
  }

  // Check if the user is onboarded or not and display change password dialog
  checkOnBoarded(data) {
    return new Promise(resolve => {
      if (data.subscriber.onboarded) {
        resolve(null);
      } else {
        this.switchDialogService.openChangePasswordDialog().subscribe(resp => {
          resolve(null);
        });
      }
    });
  }
}